var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"headline font-weight-bold main-title"},[_vm._v("のびしこがつくったサイト")]),_c('Works'),_c('Author')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }